// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "de-DE-json" + "." + "08fe1d663a2454b0ab01" + ".js";
};